import { render, staticRenderFns } from "./GroupBuyingStatistics.vue?vue&type=template&id=15694514&scoped=true&"
import script from "./GroupBuyingStatistics.vue?vue&type=script&lang=js&"
export * from "./GroupBuyingStatistics.vue?vue&type=script&lang=js&"
import style0 from "./GroupBuyingStatistics.vue?vue&type=style&index=0&id=15694514&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15694514",
  null
  
)

export default component.exports